import {useTypedSelector} from "helpers/reducers";
import {Reservation} from "types/entities/Reservation";
import {useTranslation} from "react-i18next";

export const useAccessTicketDriversAssignOptionForFamily = (selectedReservation: Reservation | null) => {
    const {t} = useTranslation();
    const sessionDriver = useTypedSelector(state => state.bookingLoginState.user);
    const familyAccounts = sessionDriver?.familyAccounts ?? [];
    const reservationDrivers = selectedReservation?.reservationDrivers ?? [];
    const reservationDriverIds  = reservationDrivers ? reservationDrivers.map(res => res.driver_id) : [];
    const familyAccountCount = familyAccounts?.length || 0;
    const assignedFamilyAccountToReservation = familyAccounts.filter(familyAccount => reservationDriverIds.includes(familyAccount.id));
    const assignedFamilyAccountToReservationCount = assignedFamilyAccountToReservation.length;
    const remainingUnassignedFamilyAccount = familyAccountCount - assignedFamilyAccountToReservationCount;

    const familyCountLabel = t("family_members_label", {
        count: remainingUnassignedFamilyAccount,
        total: familyAccountCount,
    })
    const familyAllDriversAssignedLabel = t("All members are assigned");

    const label = remainingUnassignedFamilyAccount === 0
        ? familyAllDriversAssignedLabel
        : familyCountLabel;

    const className = familyAccountCount === 0
        ? "hidden"
        : familyAccountCount === assignedFamilyAccountToReservationCount
            ? "disabled"
            : "";

    return {
        label,
        className
    }
};